import { ArrowRight } from 'lucide-react';
import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { pluralize } from '@/utils/number';
import type { MenuLabelChange } from '../utils/menuLabelRows';

interface MenuLabelSaveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  changes: MenuLabelChange[];
  isSaving: boolean;
  onSave: () => void;
}

export function MenuLabelSaveDialog({
  open,
  onOpenChange,
  changes,
  isSaving,
  onSave,
}: MenuLabelSaveDialogProps) {
  const changeCount = changes.length;

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Save these menu names?"
      description={`${String(changeCount)} ${pluralize(changeCount, 'name')} will change for everyone. People see the new names the next time they open the app.`}
      confirmLabel="Save names"
      isPending={isSaving}
      pendingLabel="Saving"
      onConfirm={onSave}
    >
      <ul className="flex max-h-72 flex-col gap-1.5 overflow-y-auto">
        {changes.map((change) => (
          <li
            key={change.menuKey}
            className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 rounded-lg bg-primary/5 px-3 py-2 text-sm"
          >
            <span className="text-muted-foreground line-through">{change.from}</span>
            <ArrowRight className="size-4 text-primary" aria-hidden />
            <span className="font-semibold text-primary-strong">{change.to}</span>
          </li>
        ))}
      </ul>
    </ConfirmDialog>
  );
}
